





































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { MailHistory } from '@/api'
@Component({
  components: {}
})
export default class MailDetailInfo extends ComponentVue {
  @Prop({
    type: Object,
    required: true
  })
  item!: MailHistory
}
